<template>
    <div class="lazy-video" :class="bemFacets">
        <img class="lazy-video--element"
                alt=""
                v-if="hasMqInformation && isMobile"
                :src="fallback">
        <video class="lazy-video--element"
                autoplay
                muted
                playsinline
                v-if="hasMqInformation && !isMobile"
                :poster="poster"
                :loop="loop ? true :null">
            <source type="video/webm" v-if="webmSrc" :src="webmSrc">
            <source type="video/mp4" v-if="mp4Src" :src="mp4Src">
        </video>
    </div>
</template>

<script>
    import isMobileMixin from 'framework/mixins/is-mobile/index';
    import bemMixin from 'framework/mixins/bem';

    export default {
        mixins: [
            isMobileMixin,
            bemMixin('lazy-video'),
        ],
        props: {
            webmSrc: {
                type: String,
                required: true,
            },
            mp4Src: {
                type: String,
                required: true,
            },
            poster: {
                type: String,
                required: true,
            },
            fallback: {
                type: String,
                required: true,
            },
            loop: {
                type: Boolean,
                default: true,
            },
        },
    };
</script>
